import { render, staticRenderFns } from "./RankQuestions.vue?vue&type=template&id=a1375a8c&"
import script from "./RankQuestions.vue?vue&type=script&lang=js&"
export * from "./RankQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports